import { schemaTypes } from '../../../constants/constants'
import ReportAPIs from '../../../APIs/ReportAPIs';
import { JSONToCSVConvertor } from '../../../helpers/helperFunctions'
import _ from 'lodash';
import moment from 'moment';
import { changeVehicle } from './historyReport/historyReport';
import {startLiveData} from '../../../components/ReportWindow/ReportWindow'
window.downloadJemCanData = []

export const dateFormat = "DD-MMM-YYYY HH:mm";
const downloadReport = (schema) => {
    if (window.downloadJemCanData){
        window.downloadJemCanData.map((data, index)=>{
            if (data.uid || data.uid == 0){
                delete data.uid
            }
        })
        JSONToCSVConvertor(window.downloadJemCanData, "CAN_Snapshot" + '_' + window.selectedVehicles[0].name + '_' + moment(Date.now()).format('DD_MM_YYYY HH:mm:ss'), false)
    }
};

let meta = [{ "battery_voltage": 'V' },
 { "current": 'A' },
 { "soc": '%' },
 { "controller_temperature": '°C' }, 
 { "motor_temperature": '°C' },
 { "speed":'Kmph'},
 { "battery_current":'A'},
 { "odometer": 'km' },
 { "soh":'%'},
 { "battery_temperature":'°C'},
 { "engine_speed": 'rpm'},
 { "vehicle_speed":'kmph'},
 { "cell_temperature_":'°C'},
 { "cell_voltage_":"V"}
]

export const bmsStateMap = [
    {key:0, value:"Reset" },
    {key:1, value:"Discharging" },
    {key:2, value:"Discharged" },
    {key:3, value:"Charging" },
    {key:4, value:"Charged" },
    {key:5, value:"State fault (Ign-off)" },
    {key:6, value:"Over/Under voltage" },
    {key:7, value:"Short circuit (Fault SC)" },
    {key:8, value:"Over/Under temperature" },
    {key:9, value:"Mosfet Fail" },
    {key:10, value:"Shutdown" },
    {key:11, value:"Thermal Runaway" },
    {key:12, value:"Charger Authentication Fail (Fault UT)" },
    {key:13, value:"Pack Delta High" },
    {key:14, value:"Over Current (Fauly OC)" },
]
const parameters = [
    "time",
    "available_capacity",
    "soc",
    "battery_voltage",
    "current",
    "soh",
    "cycle_count",
    "current_state",
    "prev_state",
    "cell_temperature_01",
    "cell_temperature_02",
    "cell_temperature_03",
    "cell_temperature_04",
    "cell_temperature_05",
    "cell_temperature_06",
    "cell_temperature_07",
    "cell_temperature_08",
    "cell_temperature_09",
    "cell_voltage_01",
    "cell_voltage_02",
    "cell_voltage_03",
    "cell_voltage_04",
    "cell_voltage_05",
    "cell_voltage_06",
    "cell_voltage_07",
    "cell_voltage_08",
    "cell_voltage_09",
    "cell_voltage_10",
    "cell_voltage_11",
    "cell_voltage_12",
    "cell_voltage_13",
    "cell_voltage_14",
    "cell_voltage_15",
    "cell_voltage_16",
    "cell_voltage_17",
    "cell_voltage_18",
    "cell_voltage_19",
    "cell_voltage_20",
    "cell_voltage_21",
    "cell_voltage_22",
    "cell_voltage_23",
    "cell_voltage_24",
    "cell_voltage_25",
    "cell_voltage_26",
    "warning",
    "fault",
    "charging_state_command"
];

const getAllVehiceData = (schema, data, store) =>{
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    const auth = window.getAuth();
    let vehicleno = []
    if(window.downloadForAll){
        for (let idx in window.vehicleMap){
            vehicleno.push(window.vehicleMap[idx].vehicleno)
        }   
    }else if(window.selectedGroup){
        let vehicles = window.selectedGroup.vehicles
         for (let idx in vehicles){
            vehicleno.push(vehicles[idx].vehicleno)
        }   
    }
    if(!vehicleno.length){
        window.setReportWindowTabBusy(schema, false);
        store.dispatch({
            type: "ADD_INTOAST",
            data: {
              name: "No vehicle found.",
              content: "No vehicle found. Please select different group or select 'All vehicles' from dropdown",
              createAt: Date.now(),
              autoClose: 8000,
              showError:true
            },
          });
        return
    }
    let body = {
        "token": auth.token,
        "vehicleno": vehicleno
    }
    if(window.showNoGpsFixData === true){
        body.fixqfilter = false
    }
    const handleFailure = () => {
        window.setReportWindowTabBusy(schema, false);
        console.log("failed")
    }

    const getBMSvalue = (value) => {
        let stateValue = ""
        for(let idx in bmsStateMap){
            if(bmsStateMap[idx].key === value){
                stateValue = bmsStateMap[idx].value
                break
            }
        }
        return stateValue
    }

    const handleSuccess = (resp) => {
        let header = [];
        window.CANALL = []
        let emptyObjArr = []
        
        // Create a map of parameter names for easier lookup (excluding "slno")
        const parameterMap = {};
        parameters.forEach(param => {
            // Skip "slno" from parameters list
            if (param.toLowerCase() === "slno") return;
            
            // Remove units from parameter names for matching
            const baseParam = param.replace(/\(.*\)/, '').trim();
            parameterMap[baseParam.toLowerCase()] = true;
        });

        for (let i in resp) {
            // First collect all valid headers for this vehicle
            let vehicleHeaders = [];
            for (let j in resp[i]) {
                // Convert key to lowercase and remove units for matching
                const baseKey = j.replace(/\(.*\)/, '').trim().toLowerCase();
                if (parameterMap[baseKey] && !vehicleHeaders.includes(j)) {
                    vehicleHeaders.push(j);
                }
            }

            // Add to master header list
            vehicleHeaders.forEach(j => {
                if (!header.includes(j)) {
                    header.push(j);
                }
            });
        }

        for (let i in resp) {
            if (Object.keys(resp[i]).length){
                let obj = {}
                obj["vehicleno"] = i
                
                // Only process parameters that are in our list
                header.forEach(key => {
                    // Convert key to lowercase and remove units for matching
                    const baseKey = key.replace(/\(.*\)/, '').trim().toLowerCase();
                    
                    if (parameterMap[baseKey]) {
                        if (resp[i][key]) {
                            obj[key + '-Time'] = moment(resp[i][key].timestamp).format('DD-MM-YYYY  HH:mm:ss')
                            let unit = ''
                            meta.map((data, index)=>{
                                if (Object.keys(data)[0] == key){
                                    unit = Object.values(data)[0]
                                }
                            })

                            let value = null
                            if(key === "status" && window.selectedVehicles[0] && window.selectedVehicles[0].data.vehicleModel &&
                                window.selectedVehicles[0].data.vehicleModel.variant === "Lithion 500"
                            ) {
                                let keyValue = resp[i][key].value
                                value = getBMSvalue(keyValue)
                            } else if(typeof(resp[i][key].value) === 'number' && !Number.isInteger(resp[i][key].value)){
                                value = parseFloat((resp[i][key].value).toFixed(2))
                            } else {
                                value = resp[i][key].value
                            }
                            
                            if (unit){
                                obj[key + '-Value'+ '( '+unit+' )'] = value
                            } else {
                                obj[key + '-Value'] = value
                            }
                        } else {
                            obj[key + '-Time'] = ''
                            obj[key + '-Value'] = ''
                        }
                    }
                })
                
                window.CANALL.push(obj)
            } else {
                let emptyObj = {}
                emptyObj["vehicleno"] = i
                emptyObjArr.push(emptyObj)
            }
        }
        
        window.CANALL = [...window.CANALL, ...emptyObjArr]
        JSONToCSVConvertor(
            window.CANALL, 
            "CAN Snapshot For " + (window.downloadForAll ? "All Vehicles" :  window.selectedGroup.name) + " " + moment(Date.now()).format('DD_MM_YYYY HH:mm:ss'),
            false
        )
        window.setReportWindowTabBusy(schema, false);
    }

    ReportAPIs.getLatestCanData(body).then((resp) => {
        handleSuccess(resp);
    }, handleFailure)
}

export const getjemCanDataReport = (schema, data, store) => {
    // console.log("data",schema, data, store)
    let saveState = null;
    let tableStateData = null;
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    // window.renderCanTable = true
    window.renderJemCanDataReport=true
    const auth = window.getAuth();
    let vehicleno = []
    if(window.snaplive === true){
        vehicleno.push(window.canDataVehicle)
    }
    else{
        if(!data || !data.vehicle.length){
            store.dispatch({
              type: "ADD_INTOAST",
              data: {
                name: "Please select a vehicle",
                content: "Please select a vehicle",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
              },
            });
            return;
          }
        vehicleno.push(data.vehicle[0].data.vehicleno)
    }

    let body = {
        "token": auth.token,
        "vehicleno": vehicleno
    }

    const handleFailure  = () =>{getjemCanDataReport
        window.jemCanData = []
        window.downloadJemCanData = []
        window.setReportWindowTabBusy(schema, false);
        console.log("failed")
    }
    ReportAPIs.getLatestCanData(body).then((resp) => {
        handleSuccess(resp);
    }, handleFailure)

    const getBMSvalue = (value) => {
        let stateValue = ""
        for(let idx in bmsStateMap){
            if(bmsStateMap[idx].key === value){
                stateValue = bmsStateMap[idx].value
                break
            }
        }
        return stateValue
    }
    const handleSuccess = (resp) => {
        window.jemCanData = []
        window.downloadJemCanData = []
        
        // Create a map of parameter names for easier lookup (excluding "slno")
        const parameterMap = {};
        parameters.forEach(param => {
            // Skip "slno" from parameters list
            if (param.toLowerCase() === "slno") return;
            
            // Remove units from parameter names for matching
            const baseParam = param.replace(/\(.*\)/, '').trim();
            parameterMap[baseParam.toLowerCase()] = true;
        });
    
        let slnoCounter = 1; // Initialize counter for sequential numbering
        
        
        for(let idx in resp){
            let keys = Object.keys(resp[idx])
            keys.map((key,index)=>{
                // Convert key to lowercase and remove units for matching
                const baseKey = key.replace(/\(.*\)/, '').trim().toLowerCase();
                
                // Only process if the parameter is in our list
                if(parameterMap[baseKey]) {
                    let obj = {}
                    let dData = {}
                    obj.slno = slnoCounter++; // Use and increment the counter
                    obj.vehicleno = idx
                    obj.parameter = key
                    dData.slno = obj.slno
                    dData.vehicleno = idx
                    dData.parameter = key
                    
                    let unit = '';
                    // First try exact match
                    for (let item of meta) {
                        const keyName = Object.keys(item)[0];
                        if (keyName === key) {
                            unit = item[keyName];
                            break;
                        }
                    }
    
                    // If no exact match found, try pattern matching
                    if (!unit) {
                        for (let item of meta) {
                            const keyName = Object.keys(item)[0];
                            if (keyName.endsWith('_') && key.startsWith(keyName)) {
                                unit = item[keyName];
                                break;
                            }
                        }
                    }
    
                    let value = null
                    if(key === "status" && window.selectedVehicles[0] && window.selectedVehicles[0].data.vehicleModel &&
                        window.selectedVehicles[0].data.vehicleModel.variant === "Lithion 500"
                    ) {
                        let keyValue = resp[idx][key].value
                        value = getBMSvalue(keyValue)
                    } else if(typeof(resp[idx][key].value) === 'number' && !Number.isInteger(resp[idx][key].value)){
                        value = parseFloat((resp[idx][key].value).toFixed(2))
                    } else {
                        value = resp[idx][key].value
                    }
                    
                    if (unit){
                        obj.value = value+' '+unit
                        dData.value = value
                        dData.unit = unit
                    } else {
                        obj.value = value  
                        dData.value = value
                        dData.unit = ''
                    }
    
                    obj.time = moment(resp[idx][key].timestamp).format('DD-MM-YYYY  HH:mm:ss')
                    dData.time = moment(resp[idx][key].timestamp).format('DD-MM-YYYY  HH:mm:ss')
                    if(obj.uid){
                        delete obj.uid 
                    }
                    window.jemCanData.push(obj)
                    window.downloadJemCanData.push(dData)
                }
            })
        }

        // -----------------------------
        
        let canData = window.jemCanData
        
        if (schema.content[0].ref) {
            let sortObj = schema.content[0].ref.refs.table.state.sortBy
            let processed = true
            if(sortObj !== undefined){
                if(!('ascOrder' in sortObj)) {
                    sortObj.ascOrder = true;
                }
    
                let action = sortObj.ascOrder ? -1 : 1;
                if(sortObj.timestamp) {
                    canData = canData.sort(function(a, b) {
                        return (b[sortObj.timestamp] - a[sortObj.timestamp]) * action;
                    });
                } else if(canData[0]){
                    switch(typeof canData[0][sortObj.key]) {
                        case 'string':
                            canData = canData.sort(function(a, b) {
                                if(a[sortObj.key] < b[sortObj.key]) return -1 * action;
                                if(a[sortObj.key] > b[sortObj.key]) return 1 * action;
                                return 0;
                            });
                            break;
                        default:
                            canData = canData.sort(function(a, b) {
                                return (b[sortObj.key] - a[sortObj.key]) * action;
                            });
                            break;
                    }
                }
            }
            if(sortObj !== undefined){
                schema.content[0].ref.refs.table.setData(canData)
            } else {
                schema.content[0].ref.refs.table.setData(window.jemCanData)
            }
        }
        window.setReportWindowTabBusy(schema, false);
    }
}

  

const schema = {
    key: "jem_can_data_report",
    name: "Jem CAN Data Snapshot",
    toolbar: [
        {
            key: "vehicle",
            type: schemaTypes.MULTI_SELECT,
            singleSelect: true,
            storeData: (state) => {
                return {
                    data: (() => {
                        let newMap = {};
                        for (let idx in state.vehicleMap) {
                            if (idx.indexOf("user") === -1) {
                                newMap[idx] = state.vehicleMap[idx];
                            }
                        }
                        return newMap;
                    })(),
                    name: "vehicleno",
                    id: "vehicleid",
                };
            },
            onItemChange: changeVehicle.bind(this),
            defaultValue: () => {
                return {
                    data: window.selectedVehicles.map((i) => {
                        return i.id;
                    }),
                    updatedAt: window.selectedVehiclesUpdatedAt,
                };
            },
        },
        { key: "get_history", type: schemaTypes.BUTTON, name: "Get Last Snapshot", onClick: getjemCanDataReport },
        { key: "live_data", type: schemaTypes.SNAPTOGGLE},
        { key: "download", type: schemaTypes.BUTTON, iconType: 'class', icon: 'fa fa-download', onClick: downloadReport },
        { key: "download_select", type: schemaTypes.GROUP_SELECT, iconType: 'class' },
        { key: "get_history", type: schemaTypes.BUTTON, name: "Download", onClick: getAllVehiceData },
    ],
    content: [
        {
            key: 'reportwidget', type: schemaTypes.CANDATA_REPORT,
            position: {
                width: 12,
                height: 12,
                left: 0,
                top: 0
            }
        }
    ]
}
export default schema;